// extracted by mini-css-extract-plugin
export default {"download":"download___YM1jG5G"};